import script from "./AddressBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBlock.vue?vue&type=script&setup=true&lang=js"

import "./AddressBlock.vue?vue&type=style&index=0&id=7cc60d99&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc60d99"]])

export default __exports__